export enum ShiftType {
    Limit = 1,
    UnLimit = 2
}